import moment from "moment";
import * as Utils from "./utils";

const isoFormat = "HH:mm:ss";
const localeFormat = "LT";

export default class TimeFormatter {
	static toIsoString(localeTime: string): string {
		if (localeTime == null)
			return null;

		const time = moment(localeTime, [localeFormat, isoFormat]);
		if (!time.isValid())
			return null;

		const hour = Utils.leftPad(time.hour());
		const minute = Utils.leftPad(time.minute());
		const second = Utils.leftPad(time.second());

		return `${hour}:${minute}:${second}`;
	}

	static toLocaleString(isoTime: string): string {
		if (isoTime == null)
			return null;

		const time = moment(isoTime, [localeFormat, isoFormat]);
		if (time == null)
			return null;

		return time.format(localeFormat);
	}
}